import { TranslocoSharedScopeProviders } from '@eventlyte/common';
import { provideTranslocoScope } from '@jsverse/transloco';

export class TranslocoScopeProviders extends TranslocoSharedScopeProviders {
	static readonly Fields = provideTranslocoScope('fields');
	static readonly Content = provideTranslocoScope('content');
}
